import { render } from "./TranscribingIcon.vue?vue&type=template&id=3cc47240&scoped=true"
import script from "./TranscribingIcon.vue?vue&type=script&lang=js"
export * from "./TranscribingIcon.vue?vue&type=script&lang=js"

import "./TranscribingIcon.vue?vue&type=style&index=0&id=3cc47240&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cc47240"

export default script